import React from 'react'

const OfflinePaymentDenied = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="15" fill="#E81542" fillOpacity="0.15" />
            <g clipPath="url(#clip0_1664_19921)">
                <path d="M14.999 19.0576C13.9086 19.0576 13.0215 19.9447 13.0215 21.0351C13.1209 23.6549 16.8775 23.6542 16.9765 21.0351C16.9765 19.9447 16.0893 19.0576 14.999 19.0576Z" fill="#E81542" />
                <path d="M16.976 7.91318C15.9947 6.69589 14.0048 6.6953 13.0231 7.91324C12.5315 8.49848 12.3251 9.26576 12.4569 10.0183C12.8498 12.2632 13.4043 15.4315 13.6531 16.8544C13.9319 18.3522 16.0673 18.3517 16.3458 16.8545L17.5423 10.0183C17.674 9.26579 17.4676 8.49848 16.976 7.91318Z" fill="#E81542" />
            </g>
            <defs>
                <clipPath id="clip0_1664_19921">
                    <rect width="16" height="16" fill="white" transform="translate(7 7)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default OfflinePaymentDenied;